import store from '../../store'
import axios from 'axios'

export default async({ localOnly = false } = {}) => {
  let responseData = {}
  responseData.error = false;
  let defaultLanguage = '';
  if (store.state.defaultLanguage !== null) {
    defaultLanguage = (store.state.defaultLanguage).toLowerCase();
  }
  document.body.classList.add("loader-enable");
  await axios({
    url: window.cipConfig.VUE_APP_API_ENDPOINT + "app/logout",
    method: 'get',
    params: localOnly ? { local_only: 1 } : {},
    headers: {
      'X-localization': defaultLanguage
    }
  }).then((response) => {

    // remove returnUrl once loggedOut
    localStorage.removeItem('returnUrl');

    // Tag the payload so the mutation knows to skip the IdP SLO fallback.
    // Used after an IdP-initiated logout where the IdP has already ended
    // its own session and we must not bounce the user back.
    const data = { ...(response.data.data || {}), local_only: localOnly };
    store.commit('logoutUser', data)

    setTimeout(() => {
      document.body.classList.remove("loader-enable");
    }, 700)

  })
    .catch(error => {
      document.body.classList.remove("loader-enable");
      if (error.response.data.errors[0].message) {
        responseData.error = true;
        responseData.message = error.response.data.errors[0].message;
      }
    })
  return responseData;
}